import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const CabinType = ({ roles }) => {
    
    return (
        <M_Table entityName={'TransportCabinType'} filtersOnTable rolePermissions={roles} />
    )
}